import React, { useReducer, useState } from "react"
import useMediaQuery from "@material-ui/core/useMediaQuery"

import Container from "@ecom/ui/components/Container"
import Button from "@material-ui/core/Button"
import clsx from "clsx"
import { InputSlider } from "./InputSlider"
import { CheckboxBlock } from "./CheckboxBlock"
import { RightBlock } from "./RightBlock"

import { initialState, calculatorReducer } from "./reducer"
import { CalculatorMode, CalculatorProps } from "./types"
import { calculateResult, getMonthWord } from "./helpers"
import { calculatorTabs } from "./data"
import { DLClickEventExtended } from "../../../helpers/WatcherDL/DLEvents"

import * as styles from "./calculator.module.scss"

export function Calculator({ orderNum, variantStyle }: CalculatorProps) {
  const [state, dispatch] = useReducer(calculatorReducer, initialState, (prevInitialState) =>
    calculateResult(prevInitialState)
  )

  const {
    installmentSum,
    cashbackSum,
    paymentResult,
    minNum,
    maxNum,
    term,
    terms,
    mode,
    halvaDesyatka,
  } = state

  const currentSum = mode === "installment" ? installmentSum : cashbackSum
  const [activeIndex, setActiveIndex] = useState(0)

  const isLargeDesktop = useMediaQuery("(min-width:1279.5px)")

  const handleClickTab = (i: number, buttonText: string, modeTab: CalculatorMode) => {
    setActiveIndex(i)
    dispatch({ type: "SET_MODE", payload: modeTab })

    DLClickEventExtended({ name: buttonText, eventAction: "Табы", placement: "calculator" })
  }

  const onChangeCheckbox = () => {
    dispatch({ type: "SET_HALVA_DESYATKA", payload: !halvaDesyatka })

    if (!halvaDesyatka) {
      DLClickEventExtended({
        name: "С подпиской Халва.Десятка",
        eventAction: "on",
        placement: "calculator",
      })
    } else {
      DLClickEventExtended({
        name: "С подпиской Халва.Десятка",
        eventAction: "off",
        placement: "calculator",
      })
    }
  }

  const handleClickTermBtn = (termBtn: number) => {
    dispatch({ type: "SET_TERM", payload: termBtn })

    DLClickEventExtended({
      name: "Срок рассрочки",
      eventCategory: "loan_term_selection",
      eventAction: `${termBtn} мес`,
      placement: "calculator",
    })
  }

  return (
    <section
      id="calculator"
      className={clsx(styles.section, variantStyle && styles[variantStyle])}
      data-exclude={orderNum}
    >
      <Container className={styles.container}>
        <h2 className={styles.headTitle}>Посчитайте свою выгоду</h2>
        <div className={styles.headDescr}>{calculatorTabs[activeIndex].headDescr}</div>
        <div className={styles.buttonGroup}>
          {calculatorTabs.map(({ buttonText, modeTab }, i) => (
            <Button
              key={i}
              onClick={() => handleClickTab(i, buttonText, modeTab)}
              className={clsx(styles.button, { [styles.activeButton]: activeIndex === i })}
            >
              {buttonText}
            </Button>
          ))}
        </div>
        <div className={styles.wrapper}>
          <div>
            <InputSlider
              inputLabel={calculatorTabs[activeIndex].inputLabel}
              sum={currentSum}
              minNum={minNum}
              maxNum={maxNum}
              dispatch={dispatch}
            />

            {mode === "installment" && (
              <div className={styles.termBlock}>
                <div className={styles.termTitle}>Срок рассрочки</div>
                <div className={styles.termButtonGroup}>
                  {terms.map((termItem, index) => (
                    <Button
                      key={index}
                      onClick={() => handleClickTermBtn(termItem)}
                      className={clsx(styles.termButton, {
                        [styles.activeButton]: termItem === term,
                      })}
                    >
                      {termItem} {isLargeDesktop ? getMonthWord(termItem) : "мес"}
                    </Button>
                  ))}
                </div>
              </div>
            )}

            {mode === "cashback" && (
              <CheckboxBlock checkboxActive={halvaDesyatka} onChangeCheckbox={onChangeCheckbox} />
            )}

            <p className={clsx(styles.disclaimer, styles.disclaimerDesk)}>
              Расчёт калькулятора предварительный. Не&nbsp;является&nbsp;публичной&nbsp;офертой
            </p>
          </div>

          <RightBlock
            data={calculatorTabs[activeIndex].rightBlock}
            paymentResult={paymentResult}
            term={term}
            terms={terms}
            dispatch={dispatch}
          />
        </div>
        <p className={clsx(styles.disclaimer, styles.disclaimerMob)}>
          Расчёт калькулятора предварительный. <br />
          Не является публичной офертой
        </p>
      </Container>
    </section>
  )
}
